import Cookies from "js-cookie";

const CookieKeys = {
  //用户名
  qlm_username: "qlm_username",
  //用户密码
  qlm_password: "qlm_password",
  rem_login:"rem_login",
   //用户信息
   userInfo: "userInfo",
   //Token信息
   xAuthToken: "xAuthToken",
};

export { CookieKeys, Cookies };
